import React, { useCallback, useEffect, useState } from "react";
import styles from "./index.module.scss";
import DefaultCard from "components/common/Card/DefaultCard";
import Eye from "assets/icons/Eye";
import { getSettings } from "store/slices";
import { useAppSelector } from "store/hooks";
import { useLifeChoicePageContext } from "context/hooks/useLifeChoicePageContext";
import { lifeChoiseDetailsDesktop } from "constantVariables";
import useMediaQuery from "hooks/useMediaQuery";
import { t } from "i18next";
import Label from "components/common/Label";

const CourseList = ({ selectedCourse, setSelectedCourse }) => {
  const [activeTab, setActiveTab] = useState("1");
  const { dir, language } = useAppSelector(getSettings);
  const { lifeChoice } = useLifeChoicePageContext();
  const isDesktop = useMediaQuery(lifeChoiseDetailsDesktop);

  useEffect(() => {
    if (
      lifeChoice?.academy?.length &&
      isDesktop &&
      Object.keys(selectedCourse).length === 0
    ) {
      setSelectedCourse(lifeChoice.academy[0]?.courses[0]);
      setActiveTab(lifeChoice.academy[0]?.year);
    }
  }, [lifeChoice?.academy?.length, isDesktop]);

  const RenderTab = useCallback((tab) => {
    const coursesData = lifeChoice.academy.find((ele) => ele.year === tab);
    if (!coursesData) return [];

    return coursesData.courses.map(
      ({ points, _id, points_unit, title, started_quiz, ...ele }, idx) => (
        <div
          key={`--tab-${tab}-item${_id}-${idx}`}
          className={`cursor-pointer`}
          onClick={() => {
            setSelectedCourse({
              ...ele,
              points,
              _id,
              title,
              points_unit,
              started_quiz,
            });
            if (!isDesktop) {
              document.body.style.overflow = "hidden";
            }
          }}
        >
          <DefaultCard
            className={`${styles["list-card"]} py-2 lg:py-3 ${
              selectedCourse?._id == _id ? "bg-theme-purple" : ""
            }  `}
          >
            <h4
              className={`text-sm lg:text-base font-medium ${
                selectedCourse?._id == _id ? "!text-white" : ""
              }`}
            >
              {title[language].toUpperCase()}
            </h4>
            {started_quiz ? (
              <Eye fill={selectedCourse?._id == _id ? "white" : "#004E99"} />
            ) : (
              ""
            )}
            <h4
              className={`text-sm lg:text-base font-medium ${
                selectedCourse?._id == _id ? "!text-white" : ""
              }`}
            >
              {points} {t(points_unit)}
            </h4>
          </DefaultCard>
        </div>
      )
    );
  });

  return (
    <div
      className={`${styles["course-list"]} | container `}
      dir={dir}
      lang={language}
    >
      <div className={styles["heading"]}>
        <Label dir={dir}>{t("courses")}</Label>
        <div className={styles["course-list-btns"]}>
          {lifeChoice?.academy?.map((_, idx) => (
            <button
              dir={dir}
              className={`${styles["course-list-btn"]} font-semibold`}
              key={idx}
              onClick={() => setActiveTab(_.year)}
              {...(activeTab === _.year && { "aria-expanded": true })}
            >
              <h2>Y{_.year}</h2>
            </button>
          ))}
        </div>
      </div>
      <div className={styles["cards-list"]}>{RenderTab(activeTab)}</div>
    </div>
  );
};

export default CourseList;
